export default {
  businessEmail: '0410', // 公司信箱
  extensionNumber: '0420', // 分機
  businessMobileNumber: '0430', // 公務手機
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/417/s/Tube.Frontend/src/containers/App/screens/Tube/configs/fieldCodes.js
 **/